import { Param } from './../../../model/common/param';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericHttpService } from '../generic.http.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConfig } from '../../../config';
import { map } from 'rxjs/operators';
import { AssetTempRecoSave } from '../../../model/api/assets/asset-temp-reco-save';
import { AssetImportV2 } from '../../../model/common/import/asset-import-v2';
import { AssetImportV1 } from '../../../model/common/import/asset-import-v1';
import { AssetSave } from '../../../model/api/assets/asset-save';
import { AssetTransferAdd } from '../../../model/api/assets/asset-transfer-add';
import { EmployeeValidate } from '../../../model/common/import/employee-validate';
import { ImportThales } from '../../../model/common/import/import-thales';
import { ImportITThales } from '../../../model/common/import/import-IT-thales';
import { PrintLabel } from '../../../model/common/print-label';
import { AssetEmployeeSave } from '../../../model/api/assets/asset-employee-save';
// import { AuthHttp } from 'angular2-jwt';
@Injectable()
export class AssetHttpService extends GenericHttpService<any, number> {
    constructor(public http: HttpClient) {
        super(http, '', 'assets');
    }

    getDetailById(id: number): Observable<any> {
        return this.http.get(AppConfig.urlPrefix + this.url + `/detail/${id}`).pipe(
            map((data: Response) => {
                // console.log(JSON.stringify(data));
                return data;
            }));
    }

    addNewAsset(item: AssetSave): Observable<any> {
        const url: string = AppConfig.urlPrefix + this.url + '/detail';

        return this.http.post(url, item, { headers: this.headers }).pipe(
            map((data) => {
                return data;
            }));
    }

    updateAsset(item: AssetSave): Observable<any> {
        const url: string = AppConfig.urlPrefix + this.url + '/detail';
        return this.http.put(url, item, { headers: this.headers });
    }

    public uploadV1(item: AssetImportV1): Observable<any> {
        console.log(JSON.stringify(item));
        return this.http.post(AppConfig.urlPrefix + this.url + '/importv1',
            JSON.stringify(item), { headers: this.headers }).pipe(
            map((data) => {
                return data;
            }));
    }
    public uploadV2(item: AssetImportV2): Observable<any> {
        return this.http.post(AppConfig.urlPrefix + this.url + '/importv2',
            JSON.stringify(item), { headers: this.headers }).pipe(
            map((data) => {
                return data;
            }));
    }

    public uploadThales(item: ImportThales): Observable<any> {
        return this.http.post(AppConfig.urlPrefix + this.url + '/importthales',
            JSON.stringify(item)).pipe(

            map((data) => {
                return data;
            }));
    }

    public uploadITThales(item: ImportITThales): Observable<any> {
        return this.http.post(AppConfig.urlPrefix + this.url + '/importitthales',
            JSON.stringify(item)).pipe(

            map((data) => {
                return data;
            }));
    }

  public deleteAssetOp(assetId: number, inventoryId: number ): Observable<any> {
    console.log(AppConfig.urlPrefix + this.url + `/${assetId}`, inventoryId);
    return this.http.delete(AppConfig.urlPrefix + this.url + '/deleteAssetOp' + `/${assetId}, ${inventoryId}`);
}

public exportIn(params: Array<Param>) {
    let searchParams: HttpParams = null;
    let url = AppConfig.urlPrefix + this.url + '/exportIn';

    searchParams = this.getSearchParams(params);
    return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob' }).pipe(
                    map(res => res));
}

public exportOtp(params: Array<Param>) {
    let searchParams: HttpParams = null;
    let url = AppConfig.urlPrefix + this.url + '/exportOtp';

    searchParams = this.getSearchParams(params);
    return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob' }).pipe(
                    map(res => res));
}

public exportOut(params: Array<Param>) {
    let searchParams: HttpParams = null;
    let url = AppConfig.urlPrefix + this.url + '/exportOut';

    searchParams = this.getSearchParams(params);
    return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob' }).pipe(
                    map(res => res));
}

public import(file: any) {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<any>(AppConfig.urlPrefix + this.url + '/upload', formData);
}

public importCassation(file: any) {
    // let input = new FormData();
    // input.append('file', file);
    // this.progressBarService.startTracking().subscribe(progress => console.log(progress));
    // return this.http
    //     .post(AppConfig.urlPrefix + this.url + '/uploadCassation', input);
}

public importInventory(file: any) {
    // let input = new FormData();
    // input.append('file', file);
    // this.progressBarService.startTracking().subscribe(progress => console.log(progress));
    // return this.http
    //     .post(AppConfig.urlPrefix + this.url + '/uploadInv', input);
}

public exportApaNova(inventoryId: number, locationId: number) {
    let searchParams: HttpParams = null;
 //   let url = AppConfig.urlPrefix + 'reporting/exportMegaImage&inventoryId=${inventoryId}&locationId=${locationId}';
    let url = `${AppConfig.urlPrefix}reporting/locationdownload/${locationId}`;

    searchParams = this.getSearchParams(null);
    return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob' }).pipe(
                    map(res => res));
}

public deleteAssetValidation(assetId: number, guid: string): Observable<any> {
    return this.http.delete(AppConfig.urlPrefix + this.url + '/deleteAsset' + `/${assetId}` +  `/${guid}`);
}

public deleteAsset(assetId: number): Observable<any> {
    return this.http.delete(AppConfig.urlPrefix + this.url + '/deleteAsset' + `/${assetId}`);
}

public reactivateAsset(assetId: number): Observable<any> {
  return this.http.get(AppConfig.urlPrefix + this.url + '/reactivateAsset' + `/${assetId}`);
}

public checkUniqueAsset(invNo: string) {
    return this.http.get(AppConfig.urlPrefix + this.url + '/checkUnique' + `/${invNo}`, { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}


// public export(params: Array<Param>) {
//     let searchParams: HttpParams = null;
//     let url = AppConfig.urlPrefix + this.url + '/export';

//     searchParams = this.getSearchParams(params);
//     return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob' }).pipe(
//                     map(res => res))
// }

public exportThales(params: Array<Param>) {
    let searchParams: HttpParams = null;
    let url = AppConfig.urlPrefix + this.url + '/exportThales';

    searchParams = this.getSearchParams(params);
    return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob' }).pipe(
                    map(res => res))
}



public saveReco(reco: AssetTempRecoSave): Observable<any> {
    // return super.create(reco, 'reco')
    return this.http.post(AppConfig.urlPrefix + this.url + '/reco', reco, { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}

public recoverAssetTemp(assetId: number, inventoryId: number): Observable<any> {
    return this.http.put(AppConfig.urlPrefix + this.url + '/recoverAssetTemp' +
     `/${assetId}/${inventoryId}`, {}).pipe(
     map((data: Response) => {
        return data;
    }));
}

public updatePrintDateLabel(assets: Array<any>) {
    return this.http
        .post(AppConfig.urlPrefix + this.url + '/uploadPrintDate', assets).pipe(
        map((data: any) => {
            return data;
        }));
}

public updateAssetName(assets: Array<any>) {
    return this.http
        .post(AppConfig.urlPrefix + this.url + '/updateAssetName', assets).pipe(
            map((data: any) => {
                return data;
            }));
}

public employeeValidate(reco: Array<EmployeeValidate>): Observable<any> {
    // return super.create(reco, 'reco')
    return this.http.post(AppConfig.urlPrefix + this.url + '/employeevalidate', JSON.stringify(reco), { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}

public employeeValidateAll(guid: string): Observable<any> {
    // return super.create(reco, 'reco')
    return this.http.post(AppConfig.urlPrefix + this.url + '/employeevalidateall/' + guid, { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}

public exportAll(params: Array<Param>) {
    let searchParams: HttpParams = null;
    let url = AppConfig.urlPrefix + this.url + '/exportAll';
    searchParams = this.getSearchParams(params);
    return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob' }).pipe(
                    map(res => res))
}


public addAssetByEmployee(reco: AssetTransferAdd): Observable<any> {
    // return super.create(reco, 'reco')
    return this.http.post(AppConfig.urlPrefix + this.url + '/addTransfer', JSON.stringify(reco), { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}


public exportSocGenEmail(params: Array<Param>) {
    let searchParams: HttpParams = null;
    let url = AppConfig.urlPrefix + this.url + '/exportSocGenEmail';

    searchParams = this.getSearchParams(params);
    return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob' }).pipe(
                    map(res => res));
}

public exportInventoryReginaMaria(params: Array<Param>) {
    let searchParams: HttpParams = null;
    let url = AppConfig.urlPrefix + this.url + '/exportInventoryReginaMaria';

    searchParams = this.getSearchParams(params);
    return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob' }).pipe(
                    map(res => res));
}

public exportInventoryAllReginaMaria(params: Array<Param>) {
    let searchParams: HttpParams = null;
    let url = AppConfig.urlPrefix + this.url + '/exportInventoryAllReginaMaria';

    searchParams = this.getSearchParams(params);
    return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob' }).pipe(
                    map(res => res));
}

// public printLocalLabel(item: Array<PrintLabel>): Observable<any> {
//     return this.http.post(AppConfig.urlPrefixPrint + 'printing',
//         JSON.stringify(item), { headers: this.headers }).pipe(
//         map((data) => {
//             return data;
//         }));
// }

public total(inventoryId: number): Observable<any> {
    return this.http.get(AppConfig.urlPrefix + this.url + '/total' + `/${inventoryId}`, { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}

public auditLocationChart(locationId: number, inventoryId: number): Observable<any> {
    return this.http.get(AppConfig.urlPrefix + this.url + '/auditLocationChart' + `/${locationId}/${inventoryId}`, { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}

public auditRegionChart(regionId: number, inventoryId: number): Observable<any> {
    return this.http.get(AppConfig.urlPrefix + this.url + '/auditRegionChart' + `/${regionId}/${inventoryId}`, { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}

public inventoryPieChartByDay(inventoryId: number): Observable<any> {
    return this.http.get(AppConfig.urlPrefix + this.url + '/inventoryPieChartByDay' + `/${inventoryId}`, { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}

public inventoryPieChartLocationFinishedByDay(inventoryId: number): Observable<any> {
    return this.http.get(AppConfig.urlPrefix + this.url + '/inventoryPieChartLocationFinishedByDay' + `/${inventoryId}`, { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}

public inventoryPieChartUserScans(inventoryId: number): Observable<any> {
    return this.http.get(AppConfig.urlPrefix + this.url + '/inventoryPieChartUserScans' + `/${inventoryId}`, { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}

public region(inventoryId: number): Observable<any> {
    return this.http.get(AppConfig.urlPrefix + this.url + '/region' + `/${inventoryId}`, { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}

public location(regionId: number, inventoryId: number): Observable<any> {
    return this.http.get(AppConfig.urlPrefix + this.url + '/location'  + `/${regionId}/${inventoryId}`, { headers: this.headers }).pipe(
    map((data: Response) => {
        return data;
    }));
}

public mapAssetTemp(model: any): Observable<any> {

    return this.http.post(AppConfig.urlPrefix + this.url + '/mapAssetTemp', model, { headers: this.headers }).pipe(
        map((res: Response) => {
            return res;
        }));
}

public printLocalLabel(item: Array<PrintLabel>): Observable<boolean> {
    return this.http.post(AppConfig.urlPrefixPrint + 'printing',
        item, { headers: this.headers }).pipe(
        map((data: boolean) => {
            return data;
        }));
}

public export(params: Array<Param>) {
    let searchParams: HttpParams = null;
    let url = AppConfig.urlPrefix + this.url + '/exportEmag';

    searchParams = this.getSearchParams(params);
    return this.http.get(url, { params: searchParams, observe: 'response', responseType: 'blob' }).pipe(
                    map(res => res))
}

addNewAssetEmployee(item: AssetEmployeeSave, guid: string): Observable<number> {
    let url: string = AppConfig.urlPrefix + this.url + '/employeedetail' +  `/${guid}` ;

    return this.http.post(url, item, { headers: this.headers }).pipe(
        map((data: number) => {
            return data;
        }));
}

updateAssetEmployee(item: AssetEmployeeSave, guid: string): Observable<number> {
    let url: string = AppConfig.urlPrefix + this.url + '/employeedetail'+  `/${guid}`;
    return this.http.put(url,item, { headers: this.headers }).pipe(
    map((data: number) => {
        return data;
    }));
}


}
